import { render, staticRenderFns } from "./ArceHome.vue?vue&type=template&id=f8934fc6&"
import script from "./ArceHome.vue?vue&type=script&lang=js&"
export * from "./ArceHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports